// @ts-ignore
import { useSelector, useDispatch } from "react-redux";
import { scheduleStatus } from "../selectors/schedule";

export const isScheduleActive = () => useSelector(scheduleStatus);
